import React from 'react'
import '../../css/cards/LearnItem.css'

const LearnItem = ({icon, title, information}) => {
    return (
        <div className="LearnItem">
            <div className="item-icon">
                <img src={icon} alt="Icon" />
            </div>
            <div className="item-content">
                <h2>{title}</h2>
                <p>{information}</p>
            </div>
        </div>
    );
}

export default LearnItem
